module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../node_modules/coffee-loader/index.js!./de-AT.coffee"));
	}, "locale/de-AT");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=locale/[name]!./app/locale/de-AT.coffee
// module id = 255
// module chunks = 97